import InstanceValidator from './InstanceValidator';

class PageValidator {
  constructor(
    { type, instanceList, settingsInstance, id },
    {
      getters: {
        instance,
        activePage,
        hasLetsbookIntegration,
        hasCRMIntegration,
      },
      state: { customerSettings },
    },
  ) {
    const createValidator = (instanceId) => ({
      instanceId,
      validator: new InstanceValidator({
        instance: instance(instanceId),
        isModal: type === 'modals',
        isEnabledParams: {
          ...customerSettings,
          page: activePage || {},
          hasLetsbookIntegration,
          hasCRMIntegration,
        },
      }),
    });
    if (type === 'pages') {
      this.instanceValidators = instanceList.map(createValidator);
      this.instanceValidators.push(createValidator(settingsInstance));
    } else {
      this.instanceValidators = [createValidator(id)];
    }
  }

  validate() {
    let isValid = true;

    this.messages = {};
    this.messagesCount = 0;

    this.instanceValidators.forEach(({ instanceId, validator }) => {
      if (!validator.validate()) {
        isValid = false;

        this.messages[instanceId] = validator.getMessages();
        this.messagesCount += Object.keys(validator.getMessages()).length;
      }
    });

    return isValid;
  }

  getMessages() {
    return this.messages;
  }

  getMessagesCount() {
    return this.messagesCount;
  }
}

export default PageValidator;
